import {
  SET_JOBS
} from 'app/actions/types';

import {
  getJobs as getJobsSvc,
  getQRCodeGenTemplates as getQRCodeGenTemplatesSvc,
  getQrCodeGenJobs as getQRCodeGenJobsSvc,
  generateQRCodeCards as generateQRCodeCardsSvc,
  removeQRCodeTemplates as removeQRCodeTemplatesSvc,
} from 'app/services/jobs';

import {
  uploadFile as uploadFileSvc
} from 'shared/services/FileService';

import {
  uploadQRTemplate as uploadQRTemplateSvc
} from 'app/services/uploads';

export const getJobs = params => async dispatch => {
  let jobs = await getJobsSvc(params);

  if (jobs) {
    dispatch({
      type: SET_JOBS,
      payload: jobs.params
    });
  }

  return jobs;
}

export const setJobParams = params => async dispatch => {
  dispatch({
    type: SET_JOBS,
    payload: params
  });
}

export const uploadQRCodeTemplate = async (jobId, params, file) => {
  const res = await uploadQRTemplateSvc(jobId, params);
  await uploadFileSvc(res.url, file);
  return res.url;
}

export const getQRCodeGenTemplates = async (jobId) => {
  const res = await getQRCodeGenTemplatesSvc(jobId);
  return res;
}

export const getQRCodeGenJobs = async (jobId) => {
  const jobs = await getQRCodeGenJobsSvc(jobId);
  return jobs;
}

export const generateQRCodeCards = async (jobId, params) => {
  const job = await generateQRCodeCardsSvc(jobId, params);
  return job;
}

export const removeQRCodeTemplates = async(jobId, params) => {
  const res = await removeQRCodeTemplatesSvc(jobId, params);
  return res;
}
